<template>
  <div>
    <div
      class="desktop-sidebar mobile-none tablet-none"
      :class="{ 'desktop-sidebar--minimized': minimized }"
      @mouseover="showMinimizeButton = true"
      @mouseleave="showMinimizeButton = false"
    >
      <div class="desktop-sidebar__header">
        <zoom-center-transition>
          <div
            v-if="showMinimizeButton && !isForceMinimized"
            class="desktop-sidebar__minimize"
            @click="handleMinimize"
          >
            <mdicon
              name="chevron-right"
              size="16"
              class="desktop-sidebar__minimize-icon"
              :class="{ 'desktop-sidebar__minimize-icon--left': minimized }"
            />
          </div>
        </zoom-center-transition>
        <LogoBox :minimized="minimized" />
        <ParvandehBox :minimized="minimized" />
        <AudioRepositoryBox :minimized="minimized" />
      </div>
      <div class="desktop-sidebar__body">
        <MenuList :minimized="minimized" />
      </div>
      <div class="desktop-sidebar__footer">
        <ProfileBox :minimized="minimized" />
      </div>
      <ParvandehNotification
        v-if="checkScreenDevice(['desktop'])"
        :rowClass="minimized ? 'right-72' : 'right-272'"
        :contentWrapperClass="minimized ? 'right-136' : 'right-336'"
      />
    </div>
  </div>
</template>

<script>
import LogoBox from "../../logo-box/LogoBox.vue";
import ParvandehBox from "../../parvandeh-box/ParvandehBox.vue";
import ProfileBox from "../../profile-box/ProfileBox.vue";
import MenuList from "../../menu-list/MenuList.vue";
import ParvandehNotification from "@/components/re-design/parvandeh-notification/ParvandehNotification.vue";
import { storeDispatcher, checkScreenDevice } from "@/shared/utils";
import { ref, toRefs, watch } from "vue";
import { AudioRepositoryBox, AudioNotification } from "../..";

export default {
  components: {
    LogoBox,
    ParvandehBox,
    ProfileBox,
    MenuList,
    ParvandehNotification,
    AudioRepositoryBox,
    AudioNotification,
  },
  props: {
    isForceMinimized: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // generate props data
    const { isForceMinimized } = toRefs(props);

    const minimized = ref(isForceMinimized.value);
    const showMinimizeButton = ref(false);
    const handleMinimize = async () => {
      if (isForceMinimized.value) return;
      minimized.value = !minimized.value;
      await storeDispatcher("minimizeSidebarDesktop", minimized);
    };

    watch(isForceMinimized, () => (minimized.value = isForceMinimized.value));

    // return data to be used in template
    return {
      isForceMinimized,
      minimized,
      showMinimizeButton,
      handleMinimize,
      checkScreenDevice,
    };
  },
};
</script>
